"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('bowl', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(6.000000, 4.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M26,40 C26,37.4236509 26.0005055,36.1330532 26.0015164,36.128207 C26.6986674,35.7816704 27.3701651,35.3912627 28.012397,34.9605962 C28.9895643,34.3053295 29.8989807,33.5568634 30.7279221,32.7279221 C33.9852814,29.4705627 36,24.9705627 36,20 C36,20 0,20 0,20 C0,24.9705627 2.01471863,29.4705627 5.27207794,32.7279221 C6.10860642,33.5644505 7.02708995,34.319024 8.01445158,34.9785654 C8.65304309,35.4051341 9.3204467,35.7919504 10.0131245,36.1354763 C10.0131245,36.1354763 10.0087497,37.4236509 10,40 L26,40 Z",
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M18,14.0083363 L18,4",
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M30,14.0083363 L30,8",
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M6,14.0083363 L6,8",
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M34,4 C31.790861,4 30,5.790861 30,8",
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M22,0 C19.790861,0 18,1.790861 18,4",
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M10,4 C7.790861,4 6,5.790861 6,8",
    strokeLinecap: props.strokeLinecap
  }))));
});

exports.default = _default;